module.exports = __webpack_public_path__ + "img/theme15.7972fd3b.png";